module.exports = __webpack_public_path__ + "static/media/hehuobanAPPruanjian.6362d8b6.png";